import React from 'react';
import { Clock, Shield, ThumbsUp, MapPin, Award, Users } from 'lucide-react';

export const WhyChooseUs = () => {
  const reasons = [
    {
      icon: Clock,
      title: 'Zeitersparnis',
      description: 'Keine langen Wartezeiten bei der Zulassungsstelle. Wir erledigen alles für Sie.'
    },
    {
      icon: Shield,
      title: 'Zuverlässig',
      description: 'Über 150 zufriedene Kunden vertrauen auf unseren professionellen Service.'
    },
    {
      icon: ThumbsUp,
      title: 'Einfach & Bequem',
      description: 'Kompletter Service aus einer Hand. Sie müssen sich um nichts kümmern.'
    },
    {
      icon: MapPin,
      title: 'Vor Ort in Velbert',
      description: 'Persönlicher Ansprechpartner direkt in Velbert-Langenberg.'
    },
    {
      icon: Award,
      title: 'Faire Preise',
      description: 'Transparente Preisgestaltung ohne versteckte Kosten. Alles inklusive.'
    },
    {
      icon: Users,
      title: 'Persönliche Beratung',
      description: 'Individuelle Beratung zu allen Fragen rund um Ihre Fahrzeugzulassung.'
    }
  ];

  return (
    <section id="why-us" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900">
            Warum M.A. Zulassungsdienst?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ihr professioneller Partner für alle Zulassungsangelegenheiten in Velbert
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => {
            const IconComponent = reason.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 hover:shadow-lg transition-shadow border border-gray-200"
              >
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                  <IconComponent className="w-6 h-6 text-blue-900" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {reason.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {reason.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};